export class FieldReportTemplateService {
    /*@ngInject*/
    constructor($interval, Restangular, moment, Auth, socket, toastr, $ngConfirm, unitService) {
        this.Restangular = Restangular;
        this.$interval = $interval;
		this.moment = moment;
		this.Restangular = Restangular;
		this.listenerMap = new Map();
		this.socket = socket;
		this.Auth = Auth;
		this.unitService = unitService;
		this.$ngConfirm = $ngConfirm;
		this.cacheTimeout = undefined;
		this.lastAccount = undefined;
        this.lastUnit = undefined;
		this.joined = false;
        this.toastr = toastr;
        this.fieldReportTemplates = [];
		this.rooms = [];
    }

    onSocketEvent(event, item, array) {
        let self = this;
        self.fieldReportTemplates = array;
        self.listenerMap.forEach((value, key) => {
            setTimeout(() => {
                value(event, item, array);
            }, 0);
        });
    }

    registerListener(context, cb) {
        let self = this;
        if (!self.lastAccount) {
            self.lastAccount = self.Auth.getCurrentAccountSync().ref;
        } else if (self.lastAccount !== self.Auth.getCurrentAccountSync().ref) {
            self.destroyService();
            self.lastAccount = self.Auth.getCurrentAccountSync().ref;
        }
        if(!self.lastUser) {
            self.lastUser = self.Auth.getCurrentUserSync()._id;
        } else if(self.lastUser !== self.Auth.getCurrentUserSync()._id) {
            self.destroyService();
            self.lastUser = self.Auth.getCurrentUserSync()._id;
        }
        let count = self.listenerMap.size;
        self.listenerMap.set(context, cb);
        // If listenermap was empty, (TODO and timer isn't running), join room, syncupdates
        if (!self.joined) {
            if (self.cacheTimeout) {
                clearTimeout(self.cacheTimeout);
                self.cacheTimeout = undefined;
            }
            return self.getFieldReportTemplates().then((fieldReportTemplates) => {
                self.socket.syncUpdates('fieldReportTemplate', self.fieldReportTemplates, self.onSocketEvent.bind(self), self);
				let filter = {};
				let hasPrivilege = self.Auth.hasPrivilegeSync('event.index',undefined,filter);
				if(hasPrivilege && filter && filter.filterParam && filter.filterParam.field == 'groups') {
					filter.filterParam.data.forEach( (group) => {
						self.socket.joinRoom(`${self.Auth.getCurrentAccountSync().ref}:*:fieldReportTemplates:${group}`);
						self.rooms.push(`${self.Auth.getCurrentAccountSync().ref}:*:fieldReportTemplates:${group}`);
					} );
				}else{
					self.socket.joinRoom(`${self.Auth.getCurrentAccountSync().ref}:*:fieldReportTemplates`);
					self.rooms.push(`${self.Auth.getCurrentAccountSync().ref}:*:fieldReportTemplates`);
				}
                self.joined = true;
                return fieldReportTemplates;
            });
        } else {
			if(self.cacheTimeout) {
				clearTimeout(self.cacheTimeout);
				self.cacheTimeout = undefined;
			}
            return self.getFieldReportTemplates();
        }
    }

    destroyService() {
        let self = this;
        if (self.joined) {
            self.socket.unsyncUpdates('fieldReportTemplate', self);
			if(self.rooms && self.rooms.length > 0) {
				self.rooms.forEach( (room) => {
					self.socket.leaveRoom(room);
				} );
				self.rooms = [];
			}
        }
        self.joined = false;
        self.fieldReportTemplates = [];
        self.listenerMap.clear();
        clearTimeout(self.cacheTimeout);
        self.cacheTimeout = undefined;
    }

    unregisterListener(context, cb) {
        let self = this;
        if (!self.lastAccount) {
            self.lastAccount = self.Auth.getCurrentAccountSync().ref;
        } else if (self.lastAccount !== self.Auth.getCurrentAccountSync().ref) {
            self.destroyService();
            self.lastAccount = self.Auth.getCurrentAccountSync().ref;
        }
        if(!self.lastUser) {
            self.lastUser = self.Auth.getCurrentUserSync()._id;
        } else if(self.lastUser !== self.Auth.getCurrentUserSync()._id) {
            self.destroyService();
            self.lastUser = self.Auth.getCurrentUserSync()._id;
        }
        self.listenerMap.delete(context);
        if (self.listenerMap.size === 0) {
            self.cacheTimeout = setTimeout(self.destroyService.bind(self), 5000);
        }
    }

    unregisterAll() {
        let self = this;
        if (!self.lastAccount) {
            self.lastAccount = self.Auth.getCurrentAccountSync().ref;
        } else if (self.lastAccount !== self.Auth.getCurrentAccountSync().ref) {
            self.destroyService();
            self.lastAccount = self.Auth.getCurrentAccountSync().ref;
        }
        if(!self.lastUser) {
            self.lastUser = self.Auth.getCurrentUserSync()._id;
        } else if(self.lastUser !== self.Auth.getCurrentUserSync()._id) {
            self.destroyService();
            self.lastUser = self.Auth.getCurrentUserSync()._id;
        }
        self.listenerMap.clear();
        if (self.listenerMap.size === 0) {
            self.cacheTimeout = setTimeout(self.destroyService.bind(self), 5000);
        }
    }

    getFieldReportTemplates(query) {
        let self = this;
        if (self.fieldReportTemplates.length > 0) {
            return new Promise(function(resolve) {
                resolve(_.cloneDeep(self.fieldReportTemplates));
            });
        }
        let lastAccount = _.cloneDeep(self.lastAccount);
        let lastUser = _.cloneDeep(self.lastUser);
        return this.Restangular.all('fieldReportTemplates').getList(query)
            .then((fieldReportTemplates) => {
                if(lastAccount == self.lastAccount && lastUser == self.lastUser) {
                    self.fieldReportTemplates = fieldReportTemplates;
                    return _.cloneDeep(fieldReportTemplates);
                }else {
                    return [];
                }
            });
    }

    getFieldReportTemplatesWithQuery(query) {
        let self = this;
        return this.Restangular.all('fieldReportTemplates').getList(query)
        .then((response) => {
            return _.cloneDeep(response);
        })
.catch((err) => {
            console.error(err);
        });
    }

    setFieldReportTemplates(fieldReportTemplates) {
        let self = this;
        self.fieldReportTemplates = fieldReportTemplates;
    }

    hasFieldReportTemplates() {
        let self = this;
        return new Promise((resolve, reject) => {
            if(self.fieldReportTemplates !== undefined) {
                resolve(true);
            } else {
                let promise = self.$interval(() => {
                    if(self.fieldReportTemplates !== undefined) {
                        resolve(true);
                        self.$interval.cancel(promise);
                    }
                }, 500, 10);

                promise.then((result) => {
                    reject(`No fieldReportTemplates have been given to fieldReportTemplateService yet`);
                });
            }
        });
    }

    getFieldReportTemplateByIDSync(fieldReportTemplateID) {
        let self = this;
        let fieldReportTemplate = _.find(self.fieldReportTemplates, (fieldReportTemplate) => {
            return fieldReportTemplate._id === fieldReportTemplateID;
        });
        return fieldReportTemplate;
    }

    saveNewFieldReportTemplate(fieldReportTemplate) {
        let self = this;
        return self.Restangular.all('fieldReportTemplates').post(fieldReportTemplate);
	}

    updateFieldReportTemplate(fieldReportTemplate) {
        let self = this;
        return self.Restangular.one('fieldReportTemplates',fieldReportTemplate._id).customPATCH(fieldReportTemplate);
	}

    removeFieldReportTemplate(fieldReportTemplate) {
        let self = this;
        if(typeof fieldReportTemplate.remove === 'function') {
            fieldReportTemplate.remove().then((response) => {
                self.toastr.info('fieldReportTemplate removed.');
            })
.catch((err) => {
                console.error(err);
                self.toastr.error('fieldReportTemplate remove failed.');
            });

        }else{
            self.Restangular.one('fieldReportTemplates',fieldReportTemplate._id).remove()
.then((response)=>{
                self.toastr.info('fieldReportTemplate removed.');
            })
.catch((err) => {
                console.error(err);
                self.toastr.error('fieldReportTemplate remove failed.');
            });

        }
    }


    getFieldReportTemplateByID(fieldReportTemplateId) {
        let self = this;
        if(self.fieldReportTemplates && self.fieldReportTemplates.length > 0) {
            let index = _.findIndex(self.fieldReportTemplates,(storedfieldReportTemplate) => {
                return storedfieldReportTemplate._id === fieldReportTemplateId;
            });

            if(index !== -1) {
                return Promise.resolve(_.cloneDeep(self.fieldReportTemplates[index]));
            }else{
                return Promise.resolve('No such fieldReportTemplate!');
            }
        }else{
            return self.Restangular.one('fieldReportTemplates',fieldReportTemplateId).get()
.then((fieldReportTemplate) => {
                if(fieldReportTemplate) {
                    return fieldReportTemplate;
                }else{
                    return 'No such fieldReportTemplate!';
                }
            });
        }
    }
}

export default angular.module('secutraqApp.dashboard')
.service('fieldReportTemplateService', FieldReportTemplateService);
